import { ref, readonly } from 'vue'

const STORAGE_KEY = 'lfr.currentUser'
const currentUser = ref<string | null>(
  typeof localStorage !== 'undefined' ? localStorage.getItem(STORAGE_KEY) : null
)

export function useAuth() {
  function selectUser(name: string) {
    localStorage.setItem(STORAGE_KEY, name)
    currentUser.value = name
  }

  function clearUser() {
    localStorage.removeItem(STORAGE_KEY)
    currentUser.value = null
  }

  return { currentUser: readonly(currentUser), selectUser, clearUser }
}
